const AbstractDojoRequestRecord = require('@/lib/PaymentMethods/Dojo/Records/Request/AbstractDojoRequestRecord');
const DojoReportNotifications = require('@/lib/PaymentMethods/Dojo/DojoReportNotifications');
const DojoReportResultStatus = require('@/lib/PaymentMethods/Dojo/DojoReportResultStatus');

class DojoReport {
    /**
     * DojoTransaction holds all the information about a SALE or REFUND request made to the Dojo API. As the transaction
     * is processed by Dojo we update this object to store the current state.
     *
     * @param {AbstractDojoRequestRecord} request A class that extends AbstractDojoRequestRecord.
     */
    constructor(request) {
        if (!request || !(request instanceof AbstractDojoRequestRecord)) {
            throw new Error('DojoReport requires a class that extends AbstractDojoRequestRecord');
        }

        /**
         * @type {AbstractDojoRequestRecord}
         */
        this.initialRequest = request;

        /**
         * @type {string|null}
         */
        this.requestId = null;

        /**
         * Axios Response
         *
         * @see https://axios-http.com/docs/res_schema
         *
         * @type {Object}
         */
        this.latestResponse = null;

        /**
         * An UPPER_SNAKES_CASE string that gives the current status of the transaction e.g. CONNECTING
         * See DojoTransactionNotifications.js
         *
         * @type {?string}
         */
        this.status = null;

        /**
         * The history of statuses returned by Dojo.
         *
         * @type {string[]}
         */
        this.notificationStack = [];

        /**
         * Is the transaction complete?
         *
         * @type {boolean}
         */
        this.isFinished = false;

        /**
         * A more detailed message than status that should be shown to the operator.
         *
         * @type {?string}
         */
        this.userMessage = null;

        /**
         * When status === TRANSACTION_FINISHED what is the result?
         * See DojoTransactionResultStatus.js
         *
         * @type {{message: ?string, class: ?string}}
         */
        this.reportResult = {
            message: null,
            class: null,
        };
    }

    addResponse(response) {
        this.latestResponse = response;

        // There should never be a scenario when we have a 2xx response without data and notifications but check anyway.
        if (response.data && response.data.notifications && response.data.notifications) {
            if (DojoReportNotifications.hasOwnProperty(response.data.notifications[0])) {
                this.status = response.data.notifications[0];
                this.notificationStack = response.data.notifications;
            } else {
                throw new Error('Unrecognised Dojo notification in response: ' + response.data.notifications[0]);
            }
        } else {
            throw new Error('Missing Dojo notification in response');
        }

        // Update the userMessage if there is a new userMessage otherwise leave any existing userMessage.
        if (response.data && response.data.userMessage) {
            this.userMessage = response.data.userMessage;
        }

        // The final state of the transaction.
        if (response.data && response.data.reportResult) {
            if (DojoReportResultStatus.hasOwnProperty(response.data.reportResult)) {
                this.reportResult.message = response.data.reportResult;
                this.isFinished = true;
            } else {
                throw new Error('Unrecognised Dojo reportResult: ' + response.data.reportResult);
            }
        }
    }
}

module.exports = DojoReport;
